import { Mail } from "lucide-react";
import { SlideHeader, Headline, Body, DeepDive } from "../shared";

export function Slide14Raise() {
  const STEPS = [
    "Prove paid demand",
    "Build the companion intelligence layer",
    "Integrate the body sensor",
    "Measure application behavior",
    "Run the first brand pilots",
  ];
  const BUDGET = [
    ["Paid Demand: $180K", "Send It trial and first paid campaign. Acquisition cost measured."],
    ["Companion Intelligence Layer: $40K", "AI app build by The Faction."],
    ["Sensor Proof of Concept: $120K", "Body sensor working with the dispenser."],
    ["Application Behavior: $90K", "200-person pilot: wrist versus bottle."],
    ["Brand Pilots & Operations: $120K", "Partner outreach, fulfillment and operations."],
    ["Reserve: $50K", "Contingency for hardware and testing."],
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-raise">
      <SlideHeader n="15" label="The Raise" />
      <Headline>
        <span className="text-accent">$600K</span> to prove the closed loop.
      </Headline>
      <Body>
        This round takes WearSpray from a patented, manufactured dispenser to a measured
        connected platform.
      </Body>
      <div className="mt-5 space-y-2 max-w-xl" data-testid="pitch-raise-steps">
        {STEPS.map((t) => (
          <div key={t} className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
            <p className="font-body text-zinc-300 text-sm md:text-base leading-relaxed">{t}</p>
          </div>
        ))}
      </div>
      <p className="font-body text-accent text-sm font-medium mt-4">
        Next: $2M+ seed round, raised on pilot data, paid demand, sensor proof and brand interest.
      </p>
      <div className="flex flex-wrap items-center gap-4 mt-5">
        <a
          href="mailto:greg@wearspray.com?subject=WearSpray%20Investment%20Inquiry"
          data-testid="pitch-raise-contact-cta"
          className="inline-flex items-center gap-2 font-body text-sm font-medium bg-[#00e5ff] text-black px-6 py-3.5 hover:bg-[#00b3cc] transition-colors"
        >
          <Mail size={16} />
          Get in Touch
        </a>
        <DeepDive testid="raise" label="Use of Funds" title="Where the $600K Goes">
          <div className="space-y-4 mt-2">
            {BUDGET.map(([t, d]) => (
              <div key={t}>
                <p className="font-heading text-white text-base font-medium">{t}</p>
                <p className="font-body text-zinc-400 text-sm leading-relaxed mt-1">{d}</p>
              </div>
            ))}
          </div>
        </DeepDive>
      </div>
    </div>
  );
}
